"use client";

import Link from "next/link";
import Image from "next/image";
import { images } from "@/config/images";
import { Caption } from "./typography";
import { externalLinks } from "@/config/externalLinks";

export function SpicenetFooter() {
  return (
    <footer className="bg-[#0E0D0B] border-t border-[#262523]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About Section */}
          <div className="lg:col-span-2">
            <Caption className="text-[#9CA3AF] text-sm leading-relaxed uppercase tracking-wide">
              SPICENET IS A BROKERAGE NETWORK FOR ALL OF DEFI, ENABLING
              UNIVERSAL ACCESS TO THE TOP DEFI VENUES ACROSS ECOSYSTEMS AND
              CREATING BETTER FINANCIAL OUTCOMES FOR ALL. OUR PRODUCTS, SPICE
              FLOW AND SPICE EDGE, GIVE BUILDERS SIMPLE, SCALABLE ACCESS TO
              LIQUIDITY AND DISTRIBUTION EVERYWHERE.
            </Caption>
          </div>

          {/* Navigate Section */}
          <div>
            <h3 className="text-white font-medium tracking-[-1.5px] text-sm mb-6 uppercase tracking-wider">
              NAVIGATE
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/quests"
                  className="text-[#9CA3AF] hover:text-white transition-colors text-sm uppercase tracking-wide"
                >
                  QUESTS
                </Link>
              </li>

              <li>
                <Link
                  href="/leaderboard"
                  className="text-[#9CA3AF] hover:text-white transition-colors text-sm uppercase tracking-wide"
                >
                  LEADERBOARD
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Section */}
          <div>
            <h3 className="text-white font-medium tracking-[-1.5px] text-sm mb-6 uppercase tracking-wider">
              FOLLOW US
            </h3>

            {/* Social Icons */}
            <div className="flex gap-3 mb-8">
              <a
                href={externalLinks.social.x}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#EA5555] flex items-center justify-center hover:bg-[#FF6666] transition-colors"
              >
                <svg
                  className="w-5 h-5 text-white"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>

              <a
                href="https://discord.gg/spicenetio"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#EA5555] flex items-center justify-center hover:bg-[#FF6666] transition-colors"
              >
                <svg
                  className="w-5 h-5 text-white"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
                </svg>
              </a>
            </div>

            <h3 className="text-white font-medium tracking-[-1.5px] text-sm mb-3 uppercase tracking-wider">
              CONTACT US
            </h3>
            <a
              href="mailto:CORE@SPICENET.IO"
              className="text-[#EA5555] hover:text-[#FF6666] transition-colors text-sm uppercase tracking-wide"
            >
              CORE@SPICENET.IO
            </a>
          </div>
        </div>

        {/* Spicenet Large Logo */}
        <div className="mt-16 mb-8">
          <Image
            src={images.logo.footer}
            alt="Spicenet"
            width={500}
            height={200}
            className="h-16 md:h-32 w-auto opacity-70"
          />
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-[#262523]">
          {/* Legal Links */}
          <div className="flex items-center gap-6">
            <Link
              href="/terms"
              className="text-[#9CA3AF] hover:text-white transition-colors text-xs uppercase tracking-wide"
            >
              TERMS & CONDITIONS
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
